export const UPDATE_TEAMS = 'UPDATE_TEAMS';
export const SET_LOADING_TEAMS = 'SET_LOADING_TEAMS';
export const SET_ACTIVE_ID = 'SET_ACTIVE_ID';
export const PUSH_TRAINED_PAGE = 'PUSH_TRAINED_PAGE';
